import { trackHubSpotPathChange } from 'services/tracking/sendHubSpotEvent';

export const changeUrlWithoutReload = (url: string) => {
  window.history.replaceState({}, '', url);

  trackHubSpotPathChange(url);
};
